import {
    OBJECT_TYPE_ROUND_TABLE,
    OBJECT_TYPE_RECTANGLE_TABLE,
    OBJECT_TYPE_ROW,
    OBJECT_TYPE_SEAT,
    OBJECT_TYPE_SECTOR,
    OBJECT_TYPE_GENERAL_ADMISSION,
    OBJECT_TYPE_SHAPE,
} from '%paysera_seat_selection/js/seatSelection/config/constants';
import compileSector from './compileSector';
import compileRoundTable from './compileRoundTable';
import compileRectangleTable from './compileRectangleTable';
import compileGeneralAdmission from './compileGeneralAdmission';
import compileShape from './compileShape';
import calculateHallCacheKey from '%paysera_seat_selection/js/seatSelection/redux/component/orm/actions/calculateHallCacheKey';
import selectHall from '%paysera_seat_selection/js/seatSelection/redux/component/orm/selectors/selectHall';
import save from '%paysera_seat_selection/js/seatSelection/redux/component/orm/actions/storage/save';
import saveViewBox from '%paysera_seat_selection/js/seatSelection/redux/component/workflow/actions/storage/save';

function compileObject(object) {
    return (dispatch, getState) => {
        if (object.objectType === OBJECT_TYPE_SECTOR) {
            dispatch(compileSector({ sector: object.id }));
        }
        if (object.objectType === OBJECT_TYPE_ROUND_TABLE) {
            dispatch(compileRoundTable({ table: object.id }));
        }
        if (object.objectType === OBJECT_TYPE_RECTANGLE_TABLE) {
            dispatch(compileRectangleTable({ table: object.id }));
        }
        if (object.objectType === OBJECT_TYPE_ROW) {
            dispatch(compileSector({ sector: object.sector.id }));
        }
        if (object.objectType === OBJECT_TYPE_SEAT) {
            if (object.row !== null) {
                dispatch(compileSector({ sector: object.row.sector.id }));
            }
            if (object.roundTable !== null) {
                dispatch(compileRoundTable({ table: object.roundTable.id }));
            }
            if (object.rectangleTable !== null) {
                dispatch(compileRectangleTable({ table: object.rectangleTable.id }));
            }
        }
        if (object.objectType === OBJECT_TYPE_GENERAL_ADMISSION) {
            dispatch(compileGeneralAdmission({ generalAdmission: object.id }));
        }
        if (object.objectType === OBJECT_TYPE_SHAPE) {
            dispatch(compileShape({ shape: object.id }));
        }

        const { entityId } = selectHall(getState());
        dispatch(save(entityId));
        dispatch(saveViewBox(entityId));
        dispatch(calculateHallCacheKey());
    };
}

export default compileObject;
